export default __webpack_public_path__ + "static/media/cemp-green-bg.be8e5150.png";